import { i18nResources } from './resources';
import { type TranslationNode, type TranslationTree } from './types';

const getNodeByPath = (dictionary: TranslationTree, key: string): TranslationNode | undefined => {
  const segments = key.split('.');
  let current: TranslationNode = dictionary;

  for (const segment of segments) {
    if (!current || typeof current === 'string' || typeof current !== 'object') {
      return undefined;
    }
    current = current[segment];
  }

  return current;
};

const interpolate = (value: string, params?: Record<string, string | number>) => {
  if (!params) {
    return value;
  }

  return Object.entries(params).reduce((acc, [paramKey, paramValue]) => {
    const token = `{{${paramKey}}}`;
    return acc.replaceAll(token, String(paramValue));
  }, value);
};

export const translate = (
  languageCode: keyof typeof i18nResources,
  key: string,
  params?: Record<string, string | number>,
  fallback?: string
): string => {
  const localizedNode = getNodeByPath(i18nResources[languageCode], key);
  if (typeof localizedNode === 'string') {
    return interpolate(localizedNode, params);
  }

  const defaultNode = getNodeByPath(i18nResources.en, key);
  if (typeof defaultNode === 'string') {
    return interpolate(defaultNode, params);
  }

  if (fallback) {
    return interpolate(fallback, params);
  }

  return key;
};
